import bannerUrl from "./assets/BEV_FY26_LCH_Campaign_Family_Static_ALL_GCM_chr_320x50_300dpi.jpg";
import AdBanner from "./AdBanner";
import { useGameConfig } from "game-config";

interface ToyotaAdBannerProps {
  showDisclaimer?: boolean;
}

export default function ToyotaAdBanner({
  showDisclaimer = true,
}: ToyotaAdBannerProps) {
  const { showSponsor } = useGameConfig();
  const isShowingSponsor = showSponsor();

  return (
    <AdBanner
      enabled={isShowingSponsor}
      showDisclaimer={showDisclaimer}
      clickthroughUrl="https://ad.doubleclick.net/ddm/trackclk/N2724.3576989TEDCONFERENCES/B35578829.446126823;dc_trk_aid=639660693;dc_trk_cid=254742418;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1"
      imgUrl={bannerUrl}
      altText="Toyota — Explore electrified vehicles"
      ariaLabel="Toyota — Explore electrified vehicles (opens in a new tab)"
    />
  );
}
